/**
 * El icono premium del Agente IA (2026-08-24): la «moneda» 3D con el bot,
 * UNA sola pieza para toda la app — diálogo, página, correo, menú, avisos.
 * `size` en píxeles del cuadrado; el bot escala dentro.
 */
import { Bot } from 'lucide-react';

export default function AgenteIcono({ size = 36, className = '' }) {
  const radio = size >= 32 ? 'rounded-xl' : 'rounded-lg';
  return (
    <span
      style={{ width: size, height: size }}
      className={`agente-moneda inline-flex items-center justify-center shrink-0 ${radio} ${className}`}
      aria-hidden="true"
    >
      <Bot style={{ width: Math.round(size * 0.56), height: Math.round(size * 0.56) }} className="text-white" />
    </span>
  );
}
